module.exports = __webpack_public_path__ + "img/PxMP.69efb36f.png";